import { useNavigate } from 'react-router-dom';
import { TrackingFrom, useTrackingLocation } from './useTrackingLocation';
import { useCallback } from 'react';

export const useNavigateWithTracking = () => {
  const navigate = useNavigate();
  const location = useTrackingLocation();

  const navigateWithTracking = useCallback((url: string, trackingFrom?: TrackingFrom) => {
    navigate(url, {
      state: trackingFrom ?? location,
    });
  }, []);

  return navigateWithTracking;
};
